<fgb-banner [pageTitle]="'marketplace.page.title' | translate" />
<fgb-page-header [pageTitle]="'featured.rewards.page.title'" [backButtonLink]="'/'" />

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container">
  <fgbcl-marketplace-list
    [isList]="true"
    [marketplaceItemView]="true"
    [marketplaceItemTypes]="[0, 1, 2]"
  ></fgbcl-marketplace-list>
</div>
